// extracted by mini-css-extract-plugin
export const notFound = "notfound-module--not-found--3QRFP";
export const contentContainer = "notfound-module--content-container--2Mrpn";
export const image = "notfound-module--image--29Qnt";
export const content = "notfound-module--content--1T8hw";